import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ACTIVE_PAYOUT_ORDERS_STATUSES } from 'constants/order.constants';
import { AdditionalOrderColumn, OrdersTab } from 'enums';
import { useOrderQueryFilters } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { FilterDefinition, OrderFilters } from 'types';
import { orderUtils } from 'utils';

import { TraderOrderList } from '../OrderList';

export const TraderActiveOrders: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders',
  });

  const additionalSortingFields = useMemo(
    () => [
      {
        label: t('sorting.max_timeout'),
        value: 'maxTimeoutAt',
      },
    ],
    [t],
  );

  const additionalFilters: FilterDefinition<OrderFilters>[] = useMemo(
    () => [orderUtils.getStatusFilterDefinition(ACTIVE_PAYOUT_ORDERS_STATUSES)],
    [],
  );

  useOrderQueryFilters();

  return (
    <TraderOrderList
      tab={OrdersTab.Active}
      additionalSortingFields={additionalSortingFields}
      additionalFilters={additionalFilters}
      additionalColumns={[
        AdditionalOrderColumn.StatusActive,
        AdditionalOrderColumn.CustomerRequisites,
        AdditionalOrderColumn.AutomationStatus,
      ]}
    />
  );
};
